import { useState, FormEvent } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import { api } from "../api/client.js";

export function IdentityVersionNewPage() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  const [traits, setTraits] = useState({
    hair_color: "",
    eye_color: "",
    skin_tone: "",
    age_appearance: "",
    body_type: "",
    style_keywords: "",
    notes: "",
  });

  function setT(k: keyof typeof traits, v: string) {
    setTraits(t => ({ ...t, [k]: v }));
  }

  async function handleSubmit(e: FormEvent) {
    e.preventDefault();
    setError("");
    setSaving(true);

    const traitsObj: Record<string, unknown> = {};
    if (traits.hair_color)     traitsObj.hair_color     = traits.hair_color;
    if (traits.eye_color)      traitsObj.eye_color      = traits.eye_color;
    if (traits.skin_tone)      traitsObj.skin_tone      = traits.skin_tone;
    if (traits.age_appearance) traitsObj.age_appearance = traits.age_appearance;
    if (traits.body_type)      traitsObj.body_type      = traits.body_type;
    if (traits.style_keywords) traitsObj.style_keywords = traits.style_keywords.split(",").map(s => s.trim()).filter(Boolean);
    if (traits.notes)          traitsObj.notes          = traits.notes;

    try {
      await api.post(`/influencers/${id}/identity-versions`, {
        traitsJson: JSON.stringify(traitsObj),
        stylePolicyVersion: "v1",
        referenceAssets: [],
      });
      navigate(`/influencers/${id}`);
    } catch (err: unknown) {
      const e = err as { data?: { message?: string } };
      setError(e.data?.message || "Error al crear versión de identidad");
    } finally {
      setSaving(false);
    }
  }

  return (
    <div>
      <div style={{ marginBottom: 16 }}>
        <Link to={`/influencers/${id}`} style={{ color: "#888", textDecoration: "none", fontSize: 13 }}>← Volver a influencer</Link>
      </div>

      <h1 style={{ fontSize: 22, fontWeight: 700, margin: "0 0 6px" }}>Nueva versión de identidad</h1>
      <p style={{ color: "#666", fontSize: 13, margin: "0 0 24px" }}>
        Define los rasgos visuales del personaje. Esta versión quedará en estado <strong>pendiente</strong> hasta que la apruebes.
      </p>

      <form onSubmit={handleSubmit} style={{ maxWidth: 560 }}>
        <div style={{ background: "#fff", borderRadius: 10, padding: 24, display: "flex", flexDirection: "column", gap: 14 }}>
          <h3 style={{ margin: 0, fontSize: 15 }}>Rasgos del personaje</h3>

          {error && <div style={{ color: "#dc2626", fontSize: 13, background: "#fef2f2", padding: "8px 12px", borderRadius: 6 }}>{error}</div>}

          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
            <label style={lbl}>Color de cabello
              <input value={traits.hair_color} onChange={e => setT("hair_color", e.target.value)} style={inp} placeholder="Castaño oscuro" />
            </label>
            <label style={lbl}>Color de ojos
              <input value={traits.eye_color} onChange={e => setT("eye_color", e.target.value)} style={inp} placeholder="Verdes" />
            </label>
            <label style={lbl}>Tono de piel
              <input value={traits.skin_tone} onChange={e => setT("skin_tone", e.target.value)} style={inp} placeholder="Mediterráneo claro" />
            </label>
            <label style={lbl}>Apariencia de edad
              <input value={traits.age_appearance} onChange={e => setT("age_appearance", e.target.value)} style={inp} placeholder="30-35 años" />
            </label>
            <label style={lbl}>Tipo de cuerpo
              <input value={traits.body_type} onChange={e => setT("body_type", e.target.value)} style={inp} placeholder="Atlético, altura media" />
            </label>
            <label style={lbl}>Palabras clave de estilo
              <input value={traits.style_keywords} onChange={e => setT("style_keywords", e.target.value)} style={inp} placeholder="casual, minimalista, natural" />
              <span style={{ fontSize: 11, color: "#aaa" }}>Separadas por comas</span>
            </label>
          </div>

          <label style={lbl}>Notas adicionales
            <textarea value={traits.notes} onChange={e => setT("notes", e.target.value)} rows={3}
              style={{ ...inp, resize: "vertical" }} placeholder="Descripción libre del personaje, personalidad, estética…" />
          </label>

          <div style={{ background: "#f0fdf4", border: "1px solid #bbf7d0", borderRadius: 6, padding: "8px 12px", fontSize: 12, color: "#166534" }}>
            Las fotos de referencia se pueden añadir más adelante. La versión se crea en estado <strong>pending</strong> — deberás aprobarla para poder usarla en sesiones.
          </div>
        </div>

        <div style={{ display: "flex", gap: 10, marginTop: 16 }}>
          <button type="submit" disabled={saving} style={{ ...btnPrim, opacity: saving ? 0.6 : 1 }}>
            {saving ? "Guardando…" : "Crear versión"}
          </button>
          <Link to={`/influencers/${id}`} style={btnSecLink}>Cancelar</Link>
        </div>
      </form>
    </div>
  );
}

const btnPrim: React.CSSProperties = { padding: "9px 20px", background: "#2d6a4f", color: "#fff", border: "none", borderRadius: 6, cursor: "pointer", fontWeight: 600, fontSize: 14 };
const btnSecLink: React.CSSProperties = { padding: "9px 16px", border: "1px solid #ddd", borderRadius: 6, cursor: "pointer", background: "none", fontSize: 13, textDecoration: "none", color: "#444", display: "inline-flex", alignItems: "center" };
const inp: React.CSSProperties = { padding: "7px 10px", border: "1px solid #ddd", borderRadius: 6, fontSize: 13, outline: "none", width: "100%", boxSizing: "border-box" };
const lbl: React.CSSProperties = { display: "flex", flexDirection: "column", gap: 4, fontSize: 13, color: "#444" };
